import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { RouterModule } from '@angular/router';
import { GoFrequencyTypeHeaderParams } from './models/go-frequency-type-header-params';

@Component({
    selector: 'app-go-frequency-type-header-renderer',
    imports: [RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-frequency-type-header-renderer.component.html',
})
export class GoFrequencyTypeHeaderRendererComponent {
    params: GoFrequencyTypeHeaderParams = {} as GoFrequencyTypeHeaderParams;

    agInit(params: ICellRendererParams & GoFrequencyTypeHeaderParams): void {
        this.params = params as GoFrequencyTypeHeaderParams;
    }

    refresh(): boolean {
        return false;
    }
}
